module.exports = __webpack_public_path__ + "static/assets/f6c7e603df1d93a09e434cd34256361b.png";